import { get } from '../../../../../assets/js/shared/data-manager';

export default class EventEpisodeList {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.blockId = $wrapper.dataset.blockId;
        this.$toggleMap = $wrapper.querySelector('[data-show-map]');
        this.$episodeWrapper = $wrapper.querySelector('[data-episode-wrapper]');
        this.$eventDetailTilesList = $wrapper.querySelector('[data-episode-tiles]');
        this.$openEventDetailTriggers = $wrapper.querySelectorAll('[data-open-event-detail]');
        this.$closeEventDetailTriggers = $wrapper.querySelectorAll('[data-close-event-detail]');
        this.$openEventEpisodeDetailTriggers = $wrapper.querySelectorAll('[data-open-event-episode-detail]');
        this.$closeEventEpisodeDetailTriggers = $wrapper.querySelectorAll('[data-close-event-episode-detail]');
        this.$eventDetailTiles = $wrapper.querySelectorAll('[data-event-detail-tile]');
        this.$eventTiles = $wrapper.querySelectorAll('[data-event]');
        this.$eventDetails = $wrapper.querySelectorAll('[data-event-detail]');
        this.$eventEpisodeDetails = $wrapper.querySelectorAll('[data-event-episode-detail]');
        this.$mapEl = $wrapper.querySelector('[data-map]');
        this.$ctas = $wrapper.querySelectorAll('[data-event-episode-cta]');
        this.markerClustersEnabled = this.$mapEl.dataset.markerClustersEnabled;
        this.markerImage = this.$mapEl.dataset.marker;
        this.mapStyle = this.$mapEl.dataset.mapStyle;
        this.map = null;
        this.markers = [];
        this.eventEpisodes = [];
        this.mapInitialized = false;

        this.initMap = this.initMap.bind(this);
        this.toggleMap = this.toggleMap.bind(this);
        this.getEventLocations = this.getEventLocations.bind(this);
        this.openEventDetail = this.openEventDetail.bind(this);
        this.closeEventDetail = this.closeEventDetail.bind(this);
        this.openEventEpisodeDetail = this.openEventEpisodeDetail.bind(this);
        this.closeEventEpisodeDetail = this.closeEventEpisodeDetail.bind(this);
        this.setActiveEventStateMarker = this.setActiveEventStateMarker.bind(this);
        this.removeActiveEventStateMarker = this.removeActiveEventStateMarker.bind(this);
        this.pushCtaClickToGtm = this.pushCtaClickToGtm.bind(this);

        if (this.$toggleMap) {
            this.$toggleMap.addEventListener('change', this.toggleMap);
        }

        this.$eventTiles.forEach($eventTile => $eventTile.addEventListener('mouseenter', this.setActiveEventStateMarker));
        this.$eventTiles.forEach($eventTile => $eventTile.addEventListener('mouseleave', this.removeActiveEventStateMarker));
        this.$openEventDetailTriggers.forEach($trigger => $trigger.addEventListener('click', this.openEventDetail));
        this.$closeEventDetailTriggers.forEach($trigger => $trigger.addEventListener('click', this.closeEventDetail));
        this.$openEventEpisodeDetailTriggers.forEach($trigger => $trigger.addEventListener('click', this.openEventEpisodeDetail));
        this.$closeEventEpisodeDetailTriggers.forEach($trigger => $trigger.addEventListener('click', this.closeEventEpisodeDetail));
        this.$ctas.forEach($trigger => $trigger.addEventListener('click', this.pushCtaClickToGtm));

        // // Listen to message from child window
        // window.addEventListener('message', (event) => {
        //     const {data, origin } = event;
        //     if (data.type === 'scroll') {
        //         console.log(data);
        //     }
        // },false);

        this.getEventLocations();
    }

    /**
     * Initialize google map
     * @return {Promise<void>}
     */
    async initMap() {
        // Request needed libraries.
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        this.map = new Map(this.$mapEl, {
            zoom: 8,
            center: { lat: 50.5039, lng: 4.4699 },
            disableDefaultUI: true,
            mapId: this.mapStyle ? this.mapStyle : "njam-map",
        });

        this.eventEpisodes.forEach((eventEpisode) => {
            if( !eventEpisode.latitude || !eventEpisode.longitude) {
                return;
            }

            const markerConfig = {
                map: this.map,
                position: {
                    lat: parseFloat(eventEpisode.latitude),
                    lng: parseFloat(eventEpisode.longitude),
                },
                title: eventEpisode.title,
            };

            const $markerImage = document.createElement('img');
            $markerImage.src = this.markerImage ? this.markerImage : '/themes/njam-2/img/marker.svg';
            $markerImage.style.width = '40px';
            markerConfig.content = $markerImage;

            // The marker, positioned at Uluru
            const marker = new AdvancedMarkerElement(markerConfig);
            marker.eventEpisode = eventEpisode;
            marker.content.classList.add('event-episode__marker');

            marker.addListener("click", () => {
                this.openEventEpisodeDetail(false, eventEpisode.slug);
            });

            this.markers.push(marker);
        });

        const bounds = new google.maps.LatLngBounds();
        this.markers.forEach(marker => bounds.extend(marker.position))
        this.map.fitBounds(bounds);

        if (this.markerClustersEnabled) {
            new markerClusterer.MarkerClusterer({
                markers: this.markers,
                map: this.map,
                // renderer: (new mapMarkerClusterRenderer())
            });
        }

        this.mapInitialized = true;
    }

    /**
     * Toggle map visibility
     */
    toggleMap() {
        if (! this.mapInitialized) {
            this.initMap();
        }

        this.$episodeWrapper.classList.toggle('event-episode-list__main--map-active');
        this.$eventDetailTilesList.classList.toggle('event-episode-list__tiles--map-active');
    }

    /**
     * Get the event locations
     */
    async getEventLocations() {
        this.eventEpisodes = await get(`${placeholders.router.request}/block/${this.blockId}/ajax/get-event-episodes`);
    }

    /**
     * Open the event detail panel
     */
    openEventDetail(e, slug) {
        const eventId =  e ? e.target.closest('[data-open-event-detail]').dataset.openEventDetail : slug;
        const $panel = this.$wrapper.querySelector('[data-event-detail="' + eventId + '"]');

        this.closeEventDetail();
        this.closeEventEpisodeDetail();
        $panel.classList.add('event-episode-list__panel--show');
        const panelPosition = $panel.getBoundingClientRect();

        parent.postMessage({
            type: 'scrollTo',
            position: panelPosition.top,
        },'https://njam.tv');

        if (! this.$episodeWrapper.classList.contains('event-episode-list__main--panel-active')) {
            this.$episodeWrapper.classList.add('event-episode-list__main--panel-active');
            this.$eventDetailTilesList.classList.add('event-episode-list__tiles--panel-active');
        }

        const dataLayerEvent = {
            // if we get an event as a param we know that the user clicked in the list
            // if no event is given the user cliced on a markerand we will push an other event
            'event': e ? 'event_episode_list_clicked' : 'event_episode_marker_clicked',
            'eventTitle': $panel.dataset.eventTitle
        };

        this.pushToGtm(dataLayerEvent);
    }

    /**
     * Close the event detail panel
     */
    closeEventDetail(e) {
        if (e) {
            e.preventDefault();
        }

        this.$eventDetails.forEach( $el => $el.classList.remove('event-episode-list__panel--show'));

        this.$episodeWrapper.classList.remove('event-episode-list__main--panel-active');
        this.$eventDetailTilesList.classList.remove('event-episode-list__tiles--panel-active');
    }

    /**
     * Open the event episode detail panel
     */
    openEventEpisodeDetail(e, slug) {
        const episodeId =  e ? e.target.closest('[data-open-event-episode-detail]').dataset.openEventEpisodeDetail : slug;
        const $panel = this.$wrapper.querySelector('[data-event-episode-detail="' + episodeId + '"]');

        this.closeEventDetail();
        this.closeEventEpisodeDetail();
        $panel.classList.add('event-episode-list__panel--show');
        const panelPosition = $panel.getBoundingClientRect();

        parent.postMessage({
            type: 'scrollTo',
            position: panelPosition.top,
        },'https://njam.tv');

        if (! this.$episodeWrapper.classList.contains('event-episode-list__main--panel-active')) {
            this.$episodeWrapper.classList.add('event-episode-list__main--panel-active');
            this.$eventDetailTilesList.classList.add('event-episode-list__tiles--panel-active');
        }

        const dataLayerEvent = {
            // if we get an event as a param we know that the user clicked in the list
            // if no event is given the user cliced on a markerand we will push an other event
            'event': e ? 'event_episode_list_clicked' : 'event_episode_marker_clicked',
            'eventEpisodeTitle': $panel.dataset.eventEpisodeTitle,
            'eventTitle': $panel.dataset.eventTitle
        };

        this.pushToGtm(dataLayerEvent);
    }

    /**
     * Close the event episode detail panel
     */
    closeEventEpisodeDetail(e) {
        if (e) {
            e.preventDefault();
        }

        this.$eventEpisodeDetails.forEach( $el => $el.classList.remove('event-episode-list__panel--show'));

        this.$episodeWrapper.classList.remove('event-episode-list__main--panel-active')
        this.$eventDetailTilesList.classList.remove('event-episode-list__tiles--panel-active');
    }

    /**
     * Bounce event marker
     * @param e
     */
    setActiveEventStateMarker(e) {
        if(! this.markers.length) {
            return;
        }

        const slug = e.target.dataset.event;
        const markers = this.markers.filter(marker => {
            return marker.eventEpisode.event.slug === slug;
        });

        markers.forEach(marker => {
            marker.content.classList.add('bounce-marker');
        });
    }

    /**
     * Stop bounce event marker
     * @param e
     */
    removeActiveEventStateMarker(e) {
        if(! this.markers.length) {
            return;
        }

        const slug = e.target.dataset.event;
        const markers = this.markers.filter(marker => marker.eventEpisode.event.slug === slug);

        markers.forEach(marker => {
            marker.content.classList.remove('bounce-marker');
        });
    }

    pushCtaClickToGtm(e) {
        const $link = e.target;
        const dataLayerEvent = {
            // if we get an event as a param we know that the user clicked in the list
            // if no event is given the user cliced on a markerand we will push an other event
            'event': 'event_episode_cta_clicked',
            'eventEpisodeCtaLink': $link.dataset.eventEpisodeLink,
            'eventEpisodeTitle': $link.dataset.eventEpisodeTitle,
            'eventTitle': $link.dataset.eventTitle
        };

        this.pushToGtm(dataLayerEvent);
    }

    pushToGtm(dataLayerEvent) {
        // check if we have a datalayer to push custom events to GTM
        if (window.dataLayer) {
            // Push to the current data Layer
            window.dataLayer.push(dataLayerEvent);
        }

        // Send message to the parent of the iframe to push the event in its own data layer
        try {
            var postObject = JSON.stringify(dataLayerEvent);
            parent.postMessage(postObject, 'https://njam.tv/');
        } catch(e) {
            window.console && window.console.log(e);
        }
    }
}

class mapMarkerClusterRenderer {
    render({ count, position }, stats, map) {
        return new google.maps.Marker({
            position,
            label: {
                text: String(count),
                fontWeight: '900',
                color: '#FFFFFF',
                className: 'event-episode-list__marker-label',
            },
            icon: {
                url: "/themes/njam-2/img/marker.svg",
                anchor: new google.maps.Point(30, 60),
            }
        });
    }
}
